import React from "react";
import { useTranslation } from "react-i18next";

function AboutUs() {
  const { t } = useTranslation();
  return (
    <div className="aboutUs-container">
      <h3>{t("about fishingfinity")}</h3>
    </div>
  );
}

export default AboutUs;
